import React from "react";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import RemoteAutoSuggest from "./RemoteAutoSuggest";
import { Formik, Field, Form } from "formik";
import { DatePicker, DateRangePicker, RangeSlider } from "rsuite";
import moment from "moment";
import { Redirect, withRouter } from 'react-router-dom';
import { Alert } from "react-bootstrap";
import { apiLoadFilter } from '../../services/apis/office/apiLoadFilter';
import { apiSaveFilter } from '../../services/apis/office/apiSaveFilter';
import { apiSaveRecentSearches } from '../../services/apis/office/apiSaveRecentSearches';
import { Url } from '../../services/utilities/util';
import LocalAutoSuggest from "./LocalAutoSuggest";

class SearchBox extends React.Component {
    state = {
        city: [],
        macromarket: [],
        micromarket: [],
        pincode: [],
        complex: [],
        building: [],
        building_grade: [],
        // propertytype: [],
        // building_category: [],
        spacetype: [],
        property_condition: [],
        tenant: [],
        // sector: [],
        developer: [],
        landlord: [],
        renewed_lease: [],
        document_type: [],
        active: [],
        Lease_Id: [],
        Sale_Id: [],
        seller: [],
        purchaser: [],
        brand_sub_category: [],
        brands_parent: [],

        securityDeposit: [0,0],
        startingRent: [0, 0],
        startingRentCarpet: [0,0],
        currentRent: [0,0],
        currentRentCarpet: [0,0],
        leaseTerm: [0, 0],
        rentFreePeriod: [0,0],
        lockinPeriod: [0, 0],
        transactionSize: [0, 0],
        perSqFt: [0,0],
        totalConsideration: [0,0],
        areaPurchased: [0,0],
        rsStartingRentPercent: [0,0],
        rsCurrentRentPercent: [0,0],


        start_leaseExpiryDate: null,
        end_leaseExpiryDate: null,
        months_leaseExpiryDate: "",

        start_lockinPeriodEndDate: null,
        end_lockinPeriodEndDate: null,
        months_lockinPeriodEndDate: "",

        start_executionDate: null,
        end_executionDate: null,
        months_executionDate: "",

        start_commencementDate: null,
        end_commencementDate: null,
        months_commencementDate: "",

        start_absorptionDate: null,
        end_absorptionDate: null,
        months_absorptionDate: "",

        start_occupancy_date_orig: null,
        end_occupancy_date_orig: null,
        months_occupancy_date_orig: "",

        floor_number: [],

        redirect: false,
        uri: '',
        showAlert: false,
        showFilter: false,
        filters: [],

        filterSaveName: '',
        saveClicked: false

    }

    componentDidMount() {
        //get filters from api
        var body = new FormData();
        body.append('screener', 'edge_retail');
        apiLoadFilter.post(body).then((res) => {
            var filters = {};
            for (let filter in res.data) {
                if(typeof res.data[filter]['main_category'] !== 'undefined')
                filters[res.data[filter]['main_category']] = []
            }

            for (let filter in res.data) {
                if(typeof res.data[filter]['main_category'] !== 'undefined')
                filters[res.data[filter]['main_category']].push(res.data[filter]);
            }

            this.setState({ showFilter: true, filters: filters });

            //check URL if it has parameters
            if (typeof Url.get.filter !== 'undefined') {
                var filterValues = JSON.parse(Url.get.filter);
                this.setState({
                    city: (typeof filterValues.city !== 'undefined') ? filterValues.city : [],
                    macromarket: (typeof filterValues.macromarket !== 'undefined') ? filterValues.macromarket : [],
                    micromarket: (typeof filterValues.micromarket !== 'undefined') ? filterValues.micromarket : [],
                    pincode: (typeof filterValues.pincode !== 'undefined') ? filterValues.pincode : [],
                    complex: (typeof filterValues.complex !== 'undefined') ? filterValues.complex : [],
                    building: (typeof filterValues.building !== 'undefined') ? filterValues.building : [],
                    building_grade: (typeof filterValues.building_grade !== 'undefined') ? filterValues.building_grade : [],
                    // propertytype: (typeof filterValues.propertytype !== 'undefined') ? filterValues.propertytype : [],
                    // building_category: (typeof filterValues.building_category !== 'undefined') ? filterValues.building_category : [],
                    spacetype: (typeof filterValues.spacetype !== 'undefined') ? filterValues.spacetype : [],
                    property_condition: (typeof filterValues.property_condition !== 'undefined') ? filterValues.property_condition : [],
                    tenant: (typeof filterValues.tenant !== 'undefined') ? filterValues.tenant : [],
                    // sector: (typeof filterValues.sector !== 'undefined') ? filterValues.sector : [],
                    developer: (typeof filterValues.developer !== 'undefined') ? filterValues.developer : [],
                    landlord: (typeof filterValues.landlord !== 'undefined') ? filterValues.landlord : [],
                    renewed_lease: (typeof filterValues.renewed_lease !== 'undefined') ? filterValues.renewed_lease : [],
                    document_type: (typeof filterValues.document_type !== 'undefined') ? filterValues.document_type : [],
                    active: (typeof filterValues.active !== 'undefined') ? filterValues.active : [],
                    Lease_Id: (typeof filterValues.Lease_Id !== 'undefined') ? filterValues.Lease_Id : [],
                    Sale_Id: (typeof filterValues.Sale_Id !== 'undefined') ? filterValues.Sale_Id : [],
                    seller: (typeof filterValues.seller !== 'undefined') ? filterValues.seller : [],
                    purchaser: (typeof filterValues.purchaser !== 'undefined') ? filterValues.purchaser : [],
                    brand_sub_category: (typeof filterValues.brand_sub_category !== 'undefined') ? filterValues.brand_sub_category : [],
                    brands_parent: (typeof filterValues.brands_parent !== 'undefined') ? filterValues.brands_parent : [],


                    securityDeposit: (typeof filterValues.securityDeposit !== 'undefined') ? filterValues.securityDeposit : [0, 0],
                    startingRent: (typeof filterValues.startingRent !== 'undefined') ? filterValues.startingRent : [0, 0],
                    startingRentCarpet: (typeof filterValues.startingRentCarpet !== 'undefined') ? filterValues.startingRentCarpet : [0, 0],
                    currentRent: (typeof filterValues.currentRent !== 'undefined') ? filterValues.currentRent : [0, 0],
                    currentRentCarpet: (typeof filterValues.currentRentCarpet !== 'undefined') ? filterValues.currentRentCarpet : [0, 0],
                    leaseTerm: (typeof filterValues.leaseTerm !== 'undefined') ? filterValues.leaseTerm : [0, 0],
                    rentFreePeriod: (typeof filterValues.rentFreePeriod !== 'undefined') ? filterValues.rentFreePeriod : [0, 0],
                    lockinPeriod: (typeof filterValues.lockinPeriod !== 'undefined') ? filterValues.lockinPeriod : [0, 0],
                    transactionSize: (typeof filterValues.transactionSize !== 'undefined') ? filterValues.transactionSize : [0, 0],
                    perSqFt: (typeof filterValues.perSqFt !== 'undefined') ? filterValues.perSqFt : [0, 0],
                    totalConsideration: (typeof filterValues.totalConsideration !== 'undefined') ? filterValues.totalConsideration : [0, 0],
                    areaPurchased: (typeof filterValues.areaPurchased !== 'undefined') ? filterValues.areaPurchased : [0, 0],
                    rsStartingRentPercent: (typeof filterValues.rsStartingRentPercent !== 'undefined') ? filterValues.rsStartingRentPercent : [0, 0],
                    rsCurrentRentPercent: (typeof filterValues.rsCurrentRentPercent !== 'undefined') ? filterValues.rsCurrentRentPercent : [0, 0],

                    start_leaseExpiryDate: (typeof filterValues.start_leaseExpiryDate !== 'undefined') ? moment(filterValues.start_leaseExpiryDate).toDate() : null,
                    end_leaseExpiryDate: (typeof filterValues.end_leaseExpiryDate !== 'undefined') ? moment(filterValues.end_leaseExpiryDate).toDate() : null,
                    months_leaseExpiryDate: (typeof filterValues.months_leaseExpiryDate !== 'undefined') ? filterValues.months_leaseExpiryDate : "",

                    start_lockinPeriodEndDate: (typeof filterValues.start_lockinPeriodEndDate !== 'undefined') ? moment(filterValues.start_lockinPeriodEndDate).toDate() : null,
                    end_lockinPeriodEndDate: (typeof filterValues.end_lockinPeriodEndDate !== 'undefined') ? moment(filterValues.end_lockinPeriodEndDate).toDate() : null,
                    months_lockinPeriodEndDate: (typeof filterValues.months_lockinPeriodEndDate !== 'undefined') ? filterValues.months_lockinPeriodEndDate : "",

                    start_executionDate: (typeof filterValues.start_executionDate !== 'undefined') ? moment(filterValues.start_executionDate).toDate() : null,
                    end_executionDate: (typeof filterValues.end_executionDate !== 'undefined') ? moment(filterValues.end_executionDate).toDate() : null,
                    months_executionDate: (typeof filterValues.months_executionDate !== 'undefined') ? filterValues.months_executionDate : "",

                    start_commencementDate: (typeof filterValues.start_commencementDate !== 'undefined') ? moment(filterValues.start_commencementDate).toDate() : null,
                    end_commencementDate: (typeof filterValues.end_commencementDate !== 'undefined') ? moment(filterValues.end_commencementDate).toDate() : null,
                    months_commencementDate: (typeof filterValues.months_commencementDate !== 'undefined') ? filterValues.months_commencementDate : "",

                    start_absorptionDate: (typeof filterValues.start_absorptionDate !== 'undefined') ? moment(filterValues.start_absorptionDate).toDate() : null,
                    end_absorptionDate: (typeof filterValues.end_absorptionDate !== 'undefined') ? moment(filterValues.end_absorptionDate).toDate() : null,
                    months_absorptionDate: (typeof filterValues.months_absorptionDate !== 'undefined') ? filterValues.months_absorptionDate : "",

                    start_occupancy_date_orig: (typeof filterValues.start_occupancy_date_orig !== 'undefined') ? moment(filterValues.start_occupancy_date_orig).toDate() : null,
                    end_occupancy_date_orig: (typeof filterValues.end_occupancy_date_orig !== 'undefined') ? moment(filterValues.end_occupancy_date_orig).toDate() : null,
                    months_occupancy_date_orig: (typeof filterValues.months_occupancy_date_orig !== 'undefined') ? filterValues.months_occupancy_date_orig : "",

                    floor_number: (typeof filterValues.floor_number !== 'undefined') ? filterValues.floor_number : [],
                });
            }
        });
    }

    render() {
        const { before } = DateRangePicker;

        const eventhandler = (component_name, component_value) => {
            this.setState({ [component_name]: component_value });
        };

        const rangeSelecter = (component_name, component_value) => {
            this.setState({ [component_name]: component_value });
        };

        const startDateHandler = (component_name, start_date) => {

            // this.state[fields['start_'+fields['filter-name']]]
            this.setState({ ['start_' + component_name]: start_date });
            if (this.state['end_' + component_name] !== null && new Date(this.state['end_' + component_name]) < new Date(start_date)) {
                this.setState({ ['end_' + component_name]: null });
            }
        };

        const endDateHandler = (component_name, end_date) => {
            this.setState({ ['end_' + component_name]: end_date });
        }

        const monthsAdd = (component_name, e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
                var newDate = moment(new Date()).add(e.target.value, 'M').toDate();
                this.setState({ ['start_' + component_name]: new Date(), ['end_' + component_name]: newDate, ['months_' + component_name]: e.target.value });
            }
        };

        const monthsSubtract = (component_name, e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
                var newDate = moment(new Date()).subtract(e.target.value, 'M').toDate();
                this.setState({ ['end_' + component_name]: new Date(), ['start_' + component_name]: newDate, ['months_' + component_name]: e.target.value });
            }
        };



        const searchBoxValidation = (values) => {
            // this.setState({saveClicked : false});
            const errors = {};
            // errors.text3 = 'Invalid email address';

            let submitValues = {};
            Object.keys(values).map((field, i) => {
                // console.log(field);
                // console.log(typeof values[field]);
                // console.log(values[field]);
                if (values[field] === null || values[field].length === 0 || values[field] === "" || (Array.isArray(values[field]) && values[field].join('|') === [0, 0].join('|'))) {

                } else {
                    submitValues[field] = values[field];
                }
            });

            if (Object.keys(submitValues).length === 0) {
                errors.error = 'Select at least one filter';
                this.setState({ showAlert: true })
            }
            return errors;
        };

        const handleSaveChange = (e) => {
            this.setState({ filterSaveName: e.target.value });
        }

        const handleSave = () => {
            // console.log(this.state)
            // let values = this.state;
            // // do what you want like on submit
            // const errors = {};
            // // errors.text3 = 'Invalid email address';

            // let submitValues = {};
            // Object.keys(values).map((field, i) => {
            //   // console.log(field);
            //   // console.log(typeof values[field]);
            //   // console.log(values[field]);
            //   if (values[field] === null || values[field].length === 0 || values[field] === "" || (Array.isArray(values[field]) && values[field].join('|') === [0, 0].join('|'))) {

            //   } else {
            //     submitValues[field] = values[field];
            //   }
            // });

            // console.log(submitValues);
            // if (Object.keys(submitValues).length !== 0) {
            //   console.log('in');
            //   errors.error = 'Select at least one filter1';
            //   this.setState({ showAlert: true })
            //   alert(errors.error);
            // }
            // console.log('out');
            // return false;
            this.setState({ saveClicked: true })
        }

        const handleReset = (resetForm) => {
            var uri = this.props.location.pathname;
            this.props.history.push(uri);
            this.setState({
                city: [],
                macromarket: [],
                micromarket: [],
                pincode: [],
                complex: [],
                building: [],
                building_grade: [],
                // propertytype: [],
                // building_category: [],
                spacetype: [],
                property_condition: [],
                tenant: [],
                // sector: [],
                developer: [],
                landlord: [],
                renewed_lease: [],
                document_type: [],
                active: [],
                Lease_Id: [],
                Sale_Id: [],
                seller: [],
                purchaser: [],
                brand_sub_category: [],
                brands_parent: [],  

                securityDeposit: [0,0],
                startingRent: [0, 0],
                startingRentCarpet: [0,0],
                currentRent: [0, 0],
                currentRentCarpet: [0,0],
                leaseTerm: [0, 0],
                rentFreePeriod: [0,0],
                lockinPeriod: [0, 0],
                transactionSize: [0, 0],
                perSqFt: [0,0],
                totalConsideration: [0,0],
                areaPurchased: [0,0],
                rsStartingRentPercent: [0,0],
                rsCurrentRentPercent: [0,0],

                start_leaseExpiryDate: null,
                end_leaseExpiryDate: null,
                months_leaseExpiryDate: "",

                start_lockinPeriodEndDate: null,
                end_lockinPeriodEndDate: null,
                months_lockinPeriodEndDate: "",

                start_executionDate: null,
                end_executionDate: null,
                months_executionDate: "",

                start_commencementDate: null,
                end_commencementDate: null,
                months_commencementDate: "",

                start_absorptionDate: null,
                end_absorptionDate: null,
                months_absorptionDate: "",

                start_occupancy_date_orig: null,
                end_occupancy_date_orig: null,
                months_occupancy_date_orig: "",

                floor_number: []
            });
            // this.props.onChange();
        };

        if (this.state.redirect === true) {
            this.state.redirect = false;
            // window.location.href = this.state.uri;
            // this.props.history.push(this.state.uri);
            return <Redirect to={this.state.uri} />;
        }

        if (this.state.showFilter === false) {
            return (
                <div className="row filterContainer">
                    <div className="col-lg-12">
                        <div>Loading Filters</div>
                    </div>
                </div>
            );
        }

        if (this.state.showFilter === true) {
            return (
                <div className="row filterContainer">
                    <div className="col-lg-12">
                        <Formik
                            initialValues={{
                                city: this.state.city,
                                macromarket: this.state.macromarket,
                                micromarket: this.state.micromarket,
                                pincode: this.state.pincode,
                                complex: this.state.complex,
                                building: this.state.building,
                                building_grade: this.state.building_grade,
                                // propertytype: this.state.propertytype,
                                // building_category: this.state.building_category,
                                spacetype: this.state.spacetype,
                                property_condition: this.state.property_condition,
                                tenant: this.state.tenant,
                                // sector: this.state.sector,
                                developer: this.state.developer,
                                landlord: this.state.landlord,
                                renewed_lease: this.state.renewed_lease,
                                document_type:this.state.document_type,
                                active: this.state.active,
                                Lease_Id: this.state.Lease_Id,
                                Sale_Id:this.state.Sale_Id,
                                seller:this.state.seller,
                                purchaser:this.state.purchaser,
                                brand_sub_category:this.state.brand_sub_category,
                                brands_parent:this.state.brands_parent,

                                securityDeposit:this.state.securityDeposit,
                                startingRent: this.state.startingRent,
                                startingRentCarpet:this.state.startingRentCarpet,
                                currentRent: this.state.currentRent,
                                currentRentCarpet:this.state.currentRentCarpet,
                                leaseTerm: this.state.leaseTerm,
                                rentFreePeriod:this.state.rentFreePeriod,
                                lockinPeriod: this.state.lockinPeriod,
                                transactionSize: this.state.transactionSize,
                                perSqFt:this.state.perSqFt,
                                totalConsideration:this.state.totalConsideration,
                                areaPurchased:this.state.areaPurchased,
                                rsStartingRentPercent:this.state.rsStartingRentPercent,
                                rsCurrentRentPercent:this.state.rsCurrentRentPercent,

                                start_leaseExpiryDate: this.state.start_leaseExpiryDate,
                                end_leaseExpiryDate: this.state.end_leaseExpiryDate,
                                months_leaseExpiryDate: this.state.months_leaseExpiryDate,

                                start_lockinPeriodEndDate: this.state.start_lockinPeriodEndDate,
                                end_lockinPeriodEndDate: this.state.end_lockinPeriodEndDate,
                                months_lockinPeriodEndDate: this.state.months_lockinPeriodEndDate,

                                start_executionDate: this.state.start_executionDate,
                                end_executionDate: this.state.end_executionDate,
                                months_executionDate: this.state.months_executionDate,

                                start_commencementDate: this.state.start_commencementDate,
                                end_commencementDate: this.state.end_commencementDate,
                                months_commencementDate: this.state.months_commencementDate,

                                start_absorptionDate: this.state.start_absorptionDate,
                                end_absorptionDate: this.state.end_absorptionDate,
                                months_absorptionDate: this.state.months_absorptionDate,

                                start_occupancy_date_orig: this.state.start_occupancy_date_orig,
                                end_occupancy_date_orig: this.state.end_occupancy_date_orig,
                                months_occupancy_date_orig: this.state.months_occupancy_date_orig,

                                floor_number: this.state.floor_number

                            }}
                            enableReinitialize
                            validate={searchBoxValidation}
                            onSubmit={(values, { setFieldError }) => {

                                let submitValues = {};
                                let urlValues = {};
                                let keyMapping = {
                                'city':'markets', 
                                'macromarket': 'macromarkets', 
                                'micromarket' : 'micromarkets',
                                'pincode' : 'pincodes', 
                                'complex' : 'complexes', 
                                'building' : 'buildings', 
                                'building_grade': 'building-grade',
                                // 'propertytype' : 'propertyTypes',
                                // 'building_category' : 'buildingCategory',
                                'spacetype' : 'spaceTypes',
                                'property_condition' : 'propertyCondition',
                                'tenant' : 'tenants',
                                // 'sector' : 'sector',
                                'developer' : 'developers',
                                'landlord' :'landlords',
                                'renewed_lease' : 'renewed-lease',
                                'document_type' : 'documentType',
                                'active' : 'lease-status',
                                'Lease_Id' : 'creid',
                                'Sale_Id':'cresaleid',
                                'seller':'seller',
                                'purchaser':'purchaser',
                                'brand_sub_category':'brand_sub_category',
                                'brands_parent':'brands_parent',

                                'securityDeposit':'securityDeposit',
                                'startingRent' : 'startingRent',
                                'startingRentCarpet' :'startingRentCarpet',
                                'currentRent' : 'currentRent',
                                'currentRentCarpet' : 'currentRentCarpet',
                                'leaseTerm' : 'leaseTerm',
                                'rentFreePeriod' : 'rentFreePeriod',
                                'lockinPeriod' : 'lockinPeriod',
                                'transactionSize' : 'transactionSize',
                                'perSqFt':'perSqFt',
                                'totalConsideration': 'totalConsideration',
                                'areaPurchased':'areaPurchased',
                                'rsStartingRentPercent':'rsStartingRentPercent',
                                'rsCurrentRentPercent':'rsCurrentRentPercent',

                                'start_leaseExpiryDate' : 'leaseExpiryDateMin',
                                'end_leaseExpiryDate' : 'leaseExpiryDateMax',
                                'start_lockinPeriodEndDate': 'lockinPeriodEndDateMin',
                                'end_lockinPeriodEndDate': 'lockinPeriodEndDateMax',
                                'start_executionDate' : 'executionDateMin',
                                'end_executionDate' : 'executionDateMax',
                                'start_commencementDate' : 'commencementDateMin',
                                'end_commencementDate' : 'commencementDateMax',
                                'start_absorptionDate' : 'absorptionDateMin',
                                'end_absorptionDate' : 'absorptionDateMax',
                                'start_occupancy_date_orig' : 'occupancy_date_origMin',
                                'end_occupancy_date_orig' : 'occupancy_date_origMax',
                                
                                'floor_number' : 'floor_number'
                            }
                                Object.keys(values).map((field, i) => {
                                    if (values[field] === null || values[field].length === 0 || values[field] === "" || (Array.isArray(values[field]) && values[field].join('|') === [0, 0].join('|'))) {
                                    } else {
                                        if (field == 'securityDeposit' || field == 'startingRent' || field == 'startingRentCarpet' || field == 'currentRent' || field == 'currentRentCarpet' || field == 'leaseTerm' || field == 'rentFreePeriod' || field == 'lockinPeriod' || field == 'transactionSize' || field == 'perSqFt' || field == 'totalConsideration' || field == 'areaPurchased' || field == 'rsStartingRentPercent' || field == 'rsCurrentRentPercent') {
                                            submitValues[field+'Start'] = [{'value': values[field][0].toString(), 'id': '', 'label' : values[field][0].toString()}];
                                            submitValues[field+'End'] = [{'value': values[field][1].toString(), 'id': '', 'label' : values[field][1].toString()}];
                                        } else if (field == 'start_leaseExpiryDate' || field == 'end_leaseExpiryDate' || field == 'start_lockinPeriodEndDate' || field == 'end_lockinPeriodEndDate' || field == 'start_executionDate' || field == 'end_executionDate' || field == 'start_commencementDate' || field == 'end_commencementDate' || field == 'start_absorptionDate' || field == 'end_absorptionDate' || field == 'start_occupancy_date_orig' || field == 'end_occupancy_date_orig') {
                                            submitValues[keyMapping[field]] = [{'value': moment(values[field]).format('X')+'000', 'id': '', 'label' : moment(values[field]).format('DD-MM-YYYY')}];
                                        }else{
                                            if(typeof keyMapping[field] !== 'undefined')    
                                            submitValues[keyMapping[field]] = values[field];
                                        }
                                        urlValues[field] = values[field];
                                    }
                                });

                                if (this.state.saveClicked) {
                                    // console.log('save here');
                                    // console.log(this.state.filterSaveName);
                                    this.setState({ showAlert: true })
                                    if (this.state.filterSaveName == '') {
                                        setFieldError('error', 'Filter name is empty');
                                        return false;
                                    }

                                    var body = new FormData();
                                    body.append('filter-name', this.state.filterSaveName);
                                    body.append('action', 2);
                                    body.append('filter-id', 0);
                                    body.append('mode', 1);
                                    body.append('present-count', 100);
                                    body.append('filter-value', JSON.stringify(submitValues));
                                    body.append('screener', 'edge_retail');
                                    apiSaveFilter.post(body).then((res) => {
                                        setFieldError('error', res.data[0]);
                                    })
                                    return false;
                                }


                                if (Object.keys(submitValues).length !== 0) {
                                    var body = new FormData();
                                    body.append('filter-value', JSON.stringify(submitValues));
                                    body.append('screener', 'edge_retail');
                                    apiSaveRecentSearches.post(body).then((res) => {
                                        setFieldError('error', res.data[0]);
                                        // var uri = this.props.history.createHref({pathname: this.props.location.pathname}) + "?filter=" + encodeURIComponent(JSON.stringify(submitValues));
                                        var uri = this.props.location.pathname + "?filter=" + encodeURIComponent(JSON.stringify(urlValues));
                                        this.setState({ uri: uri, redirect: true });
                                        this.props.onChange();
                                    });
                                    
                                }
                            }}
                        >
                            {({ errors, touched }) => (
                                <Form>

                                    <Tabs
                                        defaultActiveKey="Location"
                                        id="uncontrolled-tab-example"
                                        className="mb-3"
                                    >

                                        {
                                            Object.keys(this.state.filters).map((main_category, i) => (
                                                <Tab eventKey={main_category} title={main_category} key={main_category}>
                                                    <div className="container">
                                                        <div className="row">
                                                            {Object.values(this.state.filters)[i].map((fields) => (
                                                                <div className="col-lg-6">
                                                                    <div className="row">
                                                                        <div className="col-lg-12">
                                                                            <label>{fields.title}</label>
                                                                        </div>
                                                                        <div className="col-lg-12">
                                                                            {
                                                                                fields.type === 'autocompleteSourceDialog' ?
                                                                                    <RemoteAutoSuggest component_name={fields.params} filter_name={fields['filter-name']} onChange={eventhandler} defaultVal={this.state[fields.params]} />
                                                                                    :
                                                                                    null
                                                                            }

                                                                            {
                                                                                fields.type === 'range' ?
                                                                                    <>
                                                                                        <div>{fields.min}</div>
                                                                                        <RangeSlider component_name={fields['filter-name']} min={fields.min} max={fields.max} onChange={(nextValue) => rangeSelecter(fields['filter-name'], nextValue)} defaultValue={this.state[fields['filter-name']]} value={this.state[fields['filter-name']]} progress />
                                                                                        <div>{fields.max}</div>
                                                                                    </>
                                                                                    :
                                                                                    null
                                                                            }

                                                                            {
                                                                                fields.type === 'date' ?
                                                                                    fields['filter-name'] === 'leaseExpiryDate' || fields['filter-name'] === 'lockinPeriodEndDate' ?
                                                                                        <>
                                                                                            From: <DatePicker format="yyyy-MM-dd" placeholder="yyyy-mm-dd" ranges={[]} oneTap={true} onChange={(start_date) => startDateHandler(fields['filter-name'], start_date)} value={this.state['start_' + fields['filter-name']]} />
                                                                                            To: <DatePicker format="yyyy-MM-dd" placeholder="yyyy-mm-dd" ranges={[]} oneTap={true} onChange={(end_date) => endDateHandler(fields['filter-name'], end_date)} disabledDate={before(new Date(this.state['start_' + fields['filter-name']]))} value={this.state['end_' + fields['filter-name']]} />
                                                                                            OR
                                                                                            <Field autoComplete="off" type="text" name={'months_' + fields['filter-name']} placeholder={fields['date-helper-text-pre']} onKeyDown={(e) => monthsAdd(fields['filter-name'], e)} />
                                                                                        </>
                                                                                        :
                                                                                        fields['filter-name'] === 'executionDate' ?
                                                                                            <>
                                                                                                From: <DatePicker format="yyyy-MM-dd" placeholder="yyyy-mm-dd" ranges={[]} oneTap={true} onChange={(start_date) => startDateHandler(fields['filter-name'], start_date)} value={this.state['start_' + fields['filter-name']]} />
                                                                                                To: <DatePicker format="yyyy-MM-dd" placeholder="yyyy-mm-dd" ranges={[]} oneTap={true} onChange={(end_date) => endDateHandler(fields['filter-name'], end_date)} disabledDate={before(new Date(this.state['start_' + fields['filter-name']]))} value={this.state['end_' + fields['filter-name']]} />
                                                                                                OR
                                                                                                <Field autoComplete="off" type="text" name={'months_' + fields['filter-name']} placeholder={fields['date-helper-text-pre']} onKeyDown={(e) => monthsSubtract(fields['filter-name'], e)} />
                                                                                            </>
                                                                                            :
                                                                                            fields['filter-name'] === 'commencementDate' || fields['filter-name'] === 'absorptionDate' || fields['filter-name'] === 'occupancy_date_orig' ?
                                                                                                <>
                                                                                                    From: <DatePicker format="yyyy-MM-dd" placeholder="yyyy-mm-dd" ranges={[]} oneTap={true} onChange={(start_date) => startDateHandler(fields['filter-name'], start_date)} value={this.state['start_' + fields['filter-name']]} />
                                                                                                    To: <DatePicker format="yyyy-MM-dd" placeholder="yyyy-mm-dd" ranges={[]} oneTap={true} onChange={(end_date) => endDateHandler(fields['filter-name'], end_date)} disabledDate={before(new Date(this.state['start_' + fields['filter-name']]))} value={this.state['end_' + fields['filter-name']]} />
                                                                                                </>
                                                                                                : null
                                                                                    :
                                                                                    null
                                                                            }

                                                                            {
                                                                                fields.type === 'autocompleteSourceLocal' ?
                                                                                    <LocalAutoSuggest component_name={fields['filter-name']} filter_name={fields['filter-name']} onChange={eventhandler} defaultVal={this.state[fields['filter-name']]} options={fields.filters} />
                                                                                    :
                                                                                    null
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Tab>
                                            ))
                                        }
                                    </Tabs>

                                    <div className="row mt-5">
                                        {errors.error && this.state.showAlert === true && (
                                            <Alert
                                                variant="danger"
                                                onClose={() => this.setState({ showAlert: false })}
                                                dismissible
                                                show={this.state.showAlert}
                                            >
                                                <Alert.Heading>
                                                    {errors.error}
                                                </Alert.Heading>
                                            </Alert>
                                        )}
                                        <div className="col-lg-4">
                                            <button className="tabFormButton" type="submit" onClick={() => { this.setState({ saveClicked: false }); }}>
                                                Apply
                                            </button>
                                            <button className="tabFormButton" type="button" onClick={handleReset}>
                                                Clear
                                            </button>
                                        </div>
                                        <div className="col-lg-4">
                                            <input name="filter_name" value={this.state.filterSaveName} onChange={(e) => handleSaveChange(e)} />
                                            <button className="tabFormButton" type="submit" onClick={() => handleSave()}>
                                                Save
                                            </button>
                                            <button className="tabFormButton" type="button">
                                                Load
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(SearchBox);
